import React, { useRef } from 'react';
import styled from 'styled-components';
import { Text, ButtonPrimary, IconSpotifyLogo, cssSpacing } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';
import analytics from 'utils/client/analytics/analytics';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';
import useIsIntersectingEffect from 'utils/ubi/useIsIntersectingEffect';

const Container = styled.div`
  text-align: center;
`;

type CommunityProps = {
  ubi: UbiArticlePage;
  className?: string;
};

const Community = ({ ubi, className }: CommunityProps) => {
  const { t } = useTranslation();
  const {
    verticalConfig: {
      features: { communityLink },
    },
  } = useServerSideConstants();
  const communityRef = useRef(null);

  useIsIntersectingEffect(
    communityRef,
    (isVisible: boolean) => isVisible && communityLink && ubi.logCommunityLinkImpression(),
  );

  if (!communityLink) {
    return null;
  }

  const trackClick = () => {
    analytics.trackEvent({
      category: 'community',
      action: 'click_community_link',
      label: 'article_page',
    });
    ubi.logCommunityLink(communityLink);
  };

  return (
    <Container className={className} ref={communityRef}>
      <Text as="h2" variant="titleSmall" paddingBottom={cssSpacing('base')}>
        {t('community_cta_title')}
      </Text>
      <Text as="p" variant="bodyMedium" paddingBottom={cssSpacing('base')}>
        {t('community_cta_body')}
      </Text>
      <ButtonPrimary
        iconLeading={IconSpotifyLogo}
        href={communityLink}
        onClick={trackClick}
        target="_blank"
        rel="noreferrer"
      >
        {t('community_cta_button')}
      </ButtonPrimary>
    </Container>
  );
};

export default Community;
